import { useAuthContext } from '@repo/user-session';
import { AppProps } from 'next/dist/shared/lib/router/router';
import { ReactNode } from 'react';
import { RelayEnvironmentProvider } from 'react-relay';

import { useEnvironment } from '@/lib/relay/relay-environment';

function RelayEdkForAccessTokenProvider({ children, pageProps }: { children: ReactNode; pageProps: AppProps }) {
  const { auth } = useAuthContext();
  const { authService } = useAuthContext();
  const sessionId = authService?.sessionId || '';
  const clientSessionId = authService?.clientSessionId || '';
  const environment = useEnvironment(pageProps.initialRecords, auth.apiToken, sessionId ?? '', clientSessionId ?? '');
  return <RelayEnvironmentProvider environment={environment}>{children}</RelayEnvironmentProvider>;
}

export default RelayEdkForAccessTokenProvider;
